import useScrollToElement from '../hooks/useScrollToElement';

type ScrollToElementProps = {
  elementId: string;
  offset?: number;
};

/**
 * Component that triggers scrolling to a specified element.
 * @param {ScrollToElementProps} props - The properties object.
 * @param {string} props.elementId - The ID of the element to scroll to.
 * @returns {null} This component does not render anything.
 */
const ScrollToElement = ({ elementId, offset }: ScrollToElementProps) => {
  useScrollToElement(elementId, offset);
  return null;
};

export default ScrollToElement;
